<template>
  <div id="app">
    <!-- NAVBAR -->
    <navbar></navbar>

    <!-- ROUTER VIEW -->
    <keep-alive include="IpoCredit">
      <router-view />
    </keep-alive>

    <!-- FOOTER -->
    <app-footer id="footer"></app-footer>

    <!-- <a id="go-top" class="button" href="#" onclick="window.history.back();return false;">
      <i class="fa fa-angle-double-left"></i>
    </a>-->
    <a id="go-top" href="#" @click.prevent="goTop()" v-show="showGoTop">
      <!-- <i class="fas fa-chevron-up"></i> -->
      <!-- <img src="./assets/img/go-top.png" alt="Go Top"> -->
      <!-- <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
        <path d="M8 24l2.83 2.83L22 15.66V40h4V15.66l11.17 11.17L40 24 24 8 8 24z"/>
      </svg>-->
      <svg style="width:48px;height:48px" viewBox="-6 -6 36 36">
        <path d="M14,20H10V11L6.5,14.5L4.08,12.08L12,4.16L19.92,12.08L17.5,14.5L14,11V20Z" />
      </svg>
    </a>

    <!-- CookieConsent -->
    <cookie-consent></cookie-consent>
    <!-- <pre style="text-align:left">{{ this.$eventBus.utm }}</pre> -->
  </div>
</template>

<script>
import Navbar from '../src/components/Navbar'
import AppFooter from '../src/components/Footer'
import CookieConsent from '../src/components/CookieConsent'
export default {
  name: 'App',
  components: { Navbar, AppFooter, CookieConsent },

  data () {
    return {
      showGoTop: false
    }
  },

  methods: {
    handleScroll (event) {
      // document.location.hash = ''
      let windowHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
      let scrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop

      this.showGoTop = (scrollTop > windowHeight)
    },
    // showGoTop () {
    //   let windowHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
    //   let scrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop

    //   return (scrollTop > windowHeight)
    // },

    goTop () {
      this.$scrollTo('body')
    }
  },

  created () {
    window.addEventListener('scroll', this.handleScroll)

    this.$eventBus.utm.source = this.$route.query.utm_source
    this.$eventBus.utm.medium = this.$route.query.utm_medium
    this.$eventBus.utm.campaign = this.$route.query.utm_campaign
    this.$eventBus.utm.content = this.$route.query.utm_content
    this.$eventBus.utm.abcode = this.$route.query.utm_abcode
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>

<style lang="stylus">
// @import 'assets/fonts/Montserrat/Montserrat.css'

// html
// height 100%
#app {
  color: #2c3e50;
  text-align: center;
  font-weight: 400;
  font-family: 'Montserrat', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.section-title {
  // margin 77px auto
  text-align: center;
  font-size: 3rem; // 44px

  strong {
    font-weight: 700;
  }

  h1 {
    margin-bottom: 1rem;
    font-weight: 300;
  }

  p {
    margin-bottom: 35px;
    // color #74ccdc - 35%
    text-align: center;
    font-weight: 300;
    font-size: 1.44rem; // 22px
  }
}

.section-hr {
  margin: 17px auto 55px auto;
  width: 10vw;
  border: 1px solid #5f727f;

  @media (max-width: 768px) {
    margin: 7px auto 17px auto;
    border: 1px solid #cc3300;
  }
}

div.card-content {
  div.content {
    text-align: left;

    p:not(:last-child) {
      padding-bottom: 1em;
    }
  }
}

#go-top {
  position: fixed;
  bottom: 52px;
  z-index: 10;
  // left calc(100vw - 110px)
  width: 52px;
  height: 52px;
  border: 1px solid #b0b0b0; // #F6F5FB - 20%
  border-radius: 100px;
  background: transparent;
  color: grey;

  svg {
    fill: #b0b0b0; // #F6F5FB - 20%
  }
}

// <<< 768px
@media (max-width: 768px) {
  #go-top {
    left: calc(100vw - 52px - 26px);
  }
}

// 769px >>>
@media (min-width: 769px) {
  #go-top {
    left: calc(100vw - 52px - 52px);
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue